import { createEmptyActor } from "xstate";
const emptyActor = createEmptyActor();
let actor = emptyActor;
const listeners = /* @__PURE__ */ new Set();
function isEmptyActor(actor) {
	return actor === emptyActor;
}
function setActor(nextActor) {
	actor = nextActor;
	for (let onActorChange of listeners) onActorChange();
}
export { setActor as a, listeners as i, emptyActor as n, isEmptyActor as r, actor as t };

//# sourceMappingURL=context-ChQ0Q6hG.js.map